import React, { useState, useEffect, ChangeEvent, useRef, useCallback } from 'react';
import { Row, Col, Container,Spinner } from 'react-bootstrap';
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { PublicClientApplication } from '@azure/msal-browser';
import { useMsal, UnauthenticatedTemplate, MsalProvider } from "@azure/msal-react";
import { loginRequest, protectedResources } from '../../auth/auth-config';
import { getToken } from '../../utils/token';
import "@maersk-global/mds-react-wrapper/styles/core.css";
import './ContainerSearchPage.scss'
import Sidebar from '../../Layouts/Sidebar/Sidebar';
import ContainerDetailsTable from '../../Components/Table/Table';
import AppNavbar from '../../Layouts/Navbar/AppNavbar';
import ContainerSearchForm from '../../Components/ContainerSearchForm/ContainerSearchForm';
import "@maersk-global/mds-react-wrapper/styles/core.css";
import { postAPI } from '../../Services/APIServices';
import { McDialog, McLoadingIndicator } from '@maersk-global/mds-react-wrapper';
import { error } from 'console';

interface Filters {
  containerNumber: string[];
  bookingNumber: string;
  sealNumber: string;
  fromDate: string | null;
  toDate: string | null;

}

interface ContainerDetail {
  containerId: number;
  containerNumber: string;
  isReefer:string;
  bookingId: number;
  bookingNumber: string;
  transportationStatus:string;
  commodityName:string;
  operatorCode:string;
  transportStartDate: string | Date;
  customsSeal: string;
  shipperSeal: string;
  carrierSeal: string;
  veterinarySeal: string;
}


const MainContent: React.FC<{ msalInstance: PublicClientApplication }> = ({ msalInstance }) => {
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount() || accounts[0];
  const [filters, setFilters] = useState<Filters>({
    containerNumber: [],
    bookingNumber: '',
    sealNumber: '',
    fromDate: '',
    toDate: ''
  });

  const [isSidebarExpanded, setIsSidebarExpanded] = useState<boolean>(false);
  const [containerDetails, setContainerDetails] = useState<ContainerDetail[]>([]);
  const [isLoading,setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [dialogMessage, setDialogMessage] = useState<string>("");
  const fromDateRef = useRef<any>(null);
  const toDateRef = useRef<any>(null);


  useEffect(() => {
    const fetchAccessToken = async () => {
      try {
        const accessToken = await getToken(protectedResources.sherlock.scopes.read);
        console.log(accessToken);
      } catch (error) {
        console.error("Error fetching access token", error);
      }
    };
    fetchAccessToken();
  }, []);


 
  const handleSearch = async (containerNumbers:string[], bookingNumber:string, sealNumber:string, fromDate:string|null,toDate:string|null) => {
    setIsLoading(true);
    setErrorMessage(null);
    setContainerDetails([]);
    console.log("Container Number in handleSearch:", containerNumbers);
    console.log("Booking Number in handleSearch:", bookingNumber);
    console.log("Seal Number in handleSearch:", sealNumber);
    console.log("From Date:",fromDate);
    console.log("To Date",toDate);
    try {
      const data: ContainerDetail[] = await postAPI(`api/Container/GetContainerDetailsAsync`, {containerNumber:containerNumbers, bookingNumber, sealNumber, fromDate,toDate}
      );

      if(data && data.length>0){
      // setContainerDetails(data);
      // let filteredData=data;
      // console.log('API response', data);

      // const allContainerNumbers=Array.from(new Set(data.map((detail)=>detail.containerNumber)));

      // setFilters((prevFilters)=>({
      //   ...prevFilters,
      //   containerNumber:allContainerNumbers,
      // }));
      let filteredData = data.map((detail) => ({
        ...detail,
        transportationStatus:detail.transportationStatus ?? "N/A",
        commodityName: detail.commodityName ?? "N/A",
        operatorCode: detail.operatorCode ?? "N/A",
        isReefer: detail.isReefer ?? "N/A",
      }));
      if(fromDate||toDate){
        const from=fromDate?new Date(fromDate):null;
        const to=toDate?new Date(toDate):null;

        filteredData=data.filter((detail)=>{
          const transportStartDate=new Date(detail.transportStartDate);
          return(
            (!from || transportStartDate>=from) && 
            (!to || transportStartDate<=to)
          );
        });
      }
      setContainerDetails(filteredData);
    } else{
      // setContainerDetails([]);
      console.error("Failed to fetch container details");
      setErrorMessage("No data found for the given input.");
    }
  }
      catch (error:any) {
      console.error('Error fetching container details', error);
      if (error.response?.status === 400){
        setDialogMessage("Please enter a valid Container Number or Booking Number");
        setIsDialogOpen(true);
      }
      if( error.response?.status === 500 || error.response?.status === 504){
        setErrorMessage("Unexpected error occurred. Please try again.");
      }else{
        setErrorMessage("An error occurred while fetching data. Please try again.");
      }
    }
    finally{
      setIsLoading(false);
    }
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setDialogMessage("");
  }

  const handleFormSubmit = (data: Filters) => {
    const updatedData = {
      ...data,
      FromDate:data.fromDate || null,
      ToDate:data.toDate || null,
    }
    setFilters(updatedData);
    handleSearch(updatedData.containerNumber, updatedData.bookingNumber, updatedData.sealNumber, updatedData.FromDate,updatedData.ToDate);
    
  };

  const handleReset = () => {
    setFilters({
      containerNumber: [],
      bookingNumber: '',
      sealNumber: '',
      fromDate: '',
      toDate: ''
    });
    setContainerDetails([]);
    setErrorMessage(null);

    if (fromDateRef.current) {
      fromDateRef.current.value = '';
    }
    if (toDateRef.current) {
      toDateRef.current.value = '';
    }
  };

  const toggleSidebar = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };
  useEffect(() => {
    if (!activeAccount && accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [activeAccount, accounts, instance]);

 

  return (
    <MsalProvider instance={instance}>
      <div className='app-container'>
        {activeAccount ? (
          <>

            <AppNavbar />

            <Sidebar
              isSidebarExpanded={isSidebarExpanded}
              toggleSidebar={toggleSidebar}
            />
            <div className='content main-content'>
              {/* <header>
                <h3>Container Search Dashboard</h3>
              </header> */}

              <Container className='filters-box mds-neutral--weakest__background-color w-100'>

                <ContainerSearchForm onSubmit={handleFormSubmit} onReset={handleReset} isLoading={isLoading}/>
              
              </Container>
              {errorMessage && (
                <div className='error-message'>
                  <p>{errorMessage}</p>
                </div>
              )}
              {isLoading ? (
                <div className='loading-spinner'>
                  {/* <Spinner animation='border' role='status' className='custom-spinner'></Spinner> */}
                  <McLoadingIndicator appearance='primary'></McLoadingIndicator>
                  </div>
              ):(
              
              containerDetails.length > 0 && (
                <Container className='table-container'>
                  <div className='table-header'>
                    <h5>Results</h5>
                  </div>
                <div className="table-spacing">
                  <ContainerDetailsTable containerDetails={containerDetails} />
                </div>
                </Container>
              )
              )}
{/* 
             {containerDetails.length === 0 && !isLoading && !errorMessage && (
              <div className="no-data-message">
              <p>No Data Found.</p>
              </div>
             )} */}


              <McDialog
              heading='Invalid Input'
              body={dialogMessage}
              open={isDialogOpen}
              closing={closeDialog}
              click={closeDialog}
              >
                <McButton slot='primaryAction' dialogaction='ok' fit='medium' onClick={closeDialog}></McButton>
              </McDialog>

            </div>
          </>
        ) : (
          <UnauthenticatedTemplate>
            <Container className='text-center'>
              <h3>Please Sign in to the dashboard</h3>
              <McButton
                label='Sign-In'
                appearance='primary'
                onClick={() => instance.loginRedirect(loginRequest)}
              />
            </Container>
          </UnauthenticatedTemplate>
        )}
      </div>
    </MsalProvider>
  )
};

export default MainContent;